/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { PageContentIEnumerableResponse } from '../models';
import { PageContentRequest } from '../models';
import { PageContentResponse } from '../models';
import { PageContentStatusRequest } from '../models';
import { PageIEnumerableResponse } from '../models';
/**
 * PageAtcsApi - axios parameter creator
 * @export
 */
export const PageAtcsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminGetAllPageContentsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PageAtcs/Admin/GetAllPageContents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns Page Content by pageId
         * @param {number} pageContentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminGetPageContentPageContentIdGet: async (pageContentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageContentId' is not null or undefined
            if (pageContentId === null || pageContentId === undefined) {
                throw new RequiredError('pageContentId','Required parameter pageContentId was null or undefined when calling apiV2PageAtcsAdminGetPageContentPageContentIdGet.');
            }
            const localVarPath = `/api/v2/PageAtcs/Admin/GetPageContent/{pageContentId}`
                .replace(`{${"pageContentId"}}`, encodeURIComponent(String(pageContentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Update Page Content
         * @param {PageContentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminUpdatePageContentPost: async (body?: PageContentRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PageAtcs/Admin/UpdatePageContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Update Page Content Status
         * @param {PageContentStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminUpdatePageContentStatusPost: async (body?: PageContentStatusRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PageAtcs/Admin/UpdatePageContentStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetAllPageContentsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PageAtcs/GetAllPageContents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Page Contents by pageId
         * @param {number} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetPageContentsPageIdGet: async (pageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling apiV2PageAtcsGetPageContentsPageIdGet.');
            }
            const localVarPath = `/api/v2/PageAtcs/GetPageContents/{pageId}`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetPagesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PageAtcs/GetPages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageAtcsApi - functional programming interface
 * @export
 */
export const PageAtcsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsAdminGetAllPageContentsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContentIEnumerableResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsAdminGetAllPageContentsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns Page Content by pageId
         * @param {number} pageContentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContentResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Update Page Content
         * @param {PageContentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsAdminUpdatePageContentPost(body?: PageContentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsAdminUpdatePageContentPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Update Page Content Status
         * @param {PageContentStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsAdminUpdatePageContentStatusPost(body?: PageContentStatusRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsAdminUpdatePageContentStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsGetAllPageContentsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContentIEnumerableResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsGetAllPageContentsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Page Contents by pageId
         * @param {number} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsGetPageContentsPageIdGet(pageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContentIEnumerableResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsGetPageContentsPageIdGet(pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PageAtcsGetPagesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageIEnumerableResponse>> {
            const localVarAxiosArgs = await PageAtcsApiAxiosParamCreator(configuration).apiV2PageAtcsGetPagesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PageAtcsApi - factory interface
 * @export
 */
export const PageAtcsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminGetAllPageContentsGet(options?: any): AxiosPromise<PageContentIEnumerableResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsAdminGetAllPageContentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns Page Content by pageId
         * @param {number} pageContentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId: number, options?: any): AxiosPromise<PageContentResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Update Page Content
         * @param {PageContentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminUpdatePageContentPost(body?: PageContentRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsAdminUpdatePageContentPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Update Page Content Status
         * @param {PageContentStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsAdminUpdatePageContentStatusPost(body?: PageContentStatusRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsAdminUpdatePageContentStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns All Page Contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetAllPageContentsGet(options?: any): AxiosPromise<PageContentIEnumerableResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsGetAllPageContentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Page Contents by pageId
         * @param {number} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetPageContentsPageIdGet(pageId: number, options?: any): AxiosPromise<PageContentIEnumerableResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsGetPageContentsPageIdGet(pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PageAtcsGetPagesGet(options?: any): AxiosPromise<PageIEnumerableResponse> {
            return PageAtcsApiFp(configuration).apiV2PageAtcsGetPagesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageAtcsApi - object-oriented interface
 * @export
 * @class PageAtcsApi
 * @extends {BaseAPI}
 */
export class PageAtcsApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Returns All Page Contents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsAdminGetAllPageContentsGet(options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsAdminGetAllPageContentsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns Page Content by pageId
     * @param {number} pageContentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId: number, options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsAdminGetPageContentPageContentIdGet(pageContentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Update Page Content
     * @param {PageContentRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsAdminUpdatePageContentPost(body?: PageContentRequest, options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsAdminUpdatePageContentPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Update Page Content Status
     * @param {PageContentStatusRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsAdminUpdatePageContentStatusPost(body?: PageContentStatusRequest, options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsAdminUpdatePageContentStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns All Page Contents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsGetAllPageContentsGet(options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsGetAllPageContentsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Page Contents by pageId
     * @param {number} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsGetPageContentsPageIdGet(pageId: number, options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsGetPageContentsPageIdGet(pageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Pages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAtcsApi
     */
    public apiV2PageAtcsGetPagesGet(options?: any) {
        return PageAtcsApiFp(this.configuration).apiV2PageAtcsGetPagesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
